import { Status } from 'components/Status'
import {
  BANK_ACCOUNT_STATUS,
  BANK_ACCOUNT_STATUS_LABELS,
  BANK_ACCOUNT_STATUS_TO_CLASSNAME
} from '../BankAccountsTable/constants'

export const BankAccountDetailsStatus = ({
  status
}: {
  status?: BANK_ACCOUNT_STATUS
}) => {
  if (!status) return null
  return (
    <Status.Default className={BANK_ACCOUNT_STATUS_TO_CLASSNAME[status]}>
      {BANK_ACCOUNT_STATUS_LABELS[status]}
    </Status.Default>
  )
}
